(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["que-necesitas-hoy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.qnh-card');
  var isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  if (!isTouchDevice) return;

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (!card.classList.contains('is-active')) {
        // Primer tap: mostrar la foto de producto, no navegar todavía
        e.preventDefault();
        cards.forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
      }
      // Segundo tap sobre la misma card: se deja pasar el click y navega al producto
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
